/**
 * `password` translations, for every locale -- the username + password
 * sign-in: the sign-in form, the forced change screen, My Panel's «Change
 * password» card and the Users page dialog.
 */
export const password = {
  mn: {
    password: {
      handleLabel: 'Нэвтрэх нэр эсвэл и-мэйл',
      passwordLabel: 'Нууц үг',
      signIn: 'Нэвтрэх',
      signingIn: 'Нэвтэрч байна…',
      signInRefused: 'Нэвтрэх нэр эсвэл нууц үг буруу байна.',
      refusalCompanyDeactivated: 'Энэ компанийн хандалт унтраалттай байна. CenTrig-ээс дахин нээж өгөхийг хүсээрэй.',
      forcedTitle: 'Шинэ нууц үг сонгоно уу',
      forcedIntro: 'Үргэлжлүүлэхээс өмнө өөрийн нууц үгийг сонгоно уу.',
      currentPassword: 'Одоогийн нууц үг',
      newPassword: 'Шинэ нууц үг',
      confirmPassword: 'Шинэ нууц үгээ давтана уу',
      change: 'Нууц үг солих',
      changing: 'Хадгалж байна…',
      changed: 'Нууц үг солигдлоо.',
      cardTitle: 'Нууц үг солих',
      cardHint: 'Солиход бусад төхөөрөмж дээрх нэвтрэлт тань дуусна.',
      problemTooShort: 'Нууц үг дор хаяж 8 тэмдэгт байх ёстой.',
      problemNeedLower: 'Нууц үгэнд жижиг үсэг орох ёстой.',
      problemNeedUpper: 'Нууц үгэнд том үсэг орох ёстой.',
      problemNeedDigit: 'Нууц үгэнд тоо орох ёстой.',
      problemNeedSymbol: 'Нууц үгэнд тэмдэгт (жишээ нь - ! @) орох ёстой.',
      problemHasPersonal: 'Нууц үгэнд нэвтрэх нэр, и-мэйлийн нэр эсвэл хүний нэр орж болохгүй.',
      problemHasRun: 'Нэг тэмдэгтийг дараалуулан гурван удаа бичиж болохгүй.',
      problemHasSequence: '1234 эсвэл abcd шиг дараалал орж болохгүй.',
      refusalTooCommon: 'Энэ нууц үг хэт түгээмэл байна. Өөр нууц үг сонгоно уу.',
      rulesTitle: 'Нууц үгийн шаардлага',
      ruleMet: 'Хангасан',
      ruleNotMet: 'Хангаагүй',
      ruleLength: 'Дор хаяж 8 тэмдэгт',
      ruleLower: 'Жижиг үсэг',
      ruleUpper: 'Том үсэг',
      ruleDigit: 'Тоо',
      ruleSymbol: 'Тэмдэгт (жишээ нь - ! @)',
      rulePersonal: 'Нэвтрэх нэр, и-мэйлийн нэр, хүний нэр орохгүй',
      ruleRun: 'Нэг тэмдэгт дараалан гурав давтахгүй',
      ruleSequence: '1234, abcd шиг дараалалгүй',
      ruleCommon: 'Түгээмэл нууц үг биш (хадгалахад шалгана)',
      showPassword: 'Нууц үг харуулах',
      hidePassword: 'Нууц үг нуух',
      problemTooLong: 'Нууц үг хэт урт байна (72 байтаас ихгүй).',
      problemIsUsername: 'Нууц үг нэвтрэх нэртэй ижил байж болохгүй.',
      problemMismatch: 'Хоёр шинэ нууц үг таарахгүй байна.',
      refusalUsernameTaken: 'Энэ нэвтрэх нэрийг өөр хүн нэр эсвэл и-мэйл болгон ашиглаж байна.',
      refusalUsernameLocked: 'Энэ хүн нэвтрэх нэртэй байна; энд өөрчлөх боломжгүй.',
      refusalNotAllowed: 'Энэ бүртгэл нууц үг ашиглах боломжгүй: нууц үг зөвхөн үндсэн хандалтад зориулагдсан. Үүнээс дээш түвшин, Microsoft бүртгэлтэй эсвэл идэвхгүй бүртгэл Microsoft-оор нэвтэрнэ.',
      refusalHolderAboveBasic: 'Энэ хүн нууц үгээр нэвтэрдэг. Үндсэн хандалтаас дээш түвшин зөвхөн Microsoft-оор нэвтэрдэг тул эхлээд нууц үгийг нь устгана уу.',
      refusalNeedsEmail: 'Үндсэн хандалтаас дээш түвшинд имэйлээр ирсэн кодоор нэвтэрдэг боловч энэ хүнд имэйл алга. Эхлээд имэйл оруулна уу.',
      refusalLevelHolders: 'Энэ түвшний хэн нэгэн нууц үгээр нэвтэрдэг. Таны нэмсэн эрх зөвхөн Microsoft-оор нэвтэрдэг тул эхлээд нууц үгийг нь устгана уу.',
      refusalLevelNeedsEmail: 'Энэ түвшний хэн нэгэнд нууц үг байгаа ч имэйл алга. Таны нэмсэн эрхэд имэйлээр ирэх код хэрэгтэй тул эхлээд имэйл оруулна уу.',
      basicOnlyHint: 'Зөвхөн үндсэн хандалтын түвшнүүд харагдана: үүнээс дээш түвшин Microsoft-оор нэвтэрнэ.',
      refusalInvalid: 'Нууц үг шаардлага хангахгүй байна. Дээрх нөхцөлүүдийг хангана уу.',
      refusalCurrentWrong: 'Одоогийн нууц үг буруу байна.',
      refusalLocked: 'Хэт олон буруу оролдлого. Хэсэг хугацааны дараа дахин оролдоно уу.',
      refusalSelf: 'Өөрийн нууц үгийг энд тохируулах боломжгүй — «Миний самбар»-аас солино уу.',
      adminAction: 'Нууц үг',
      adminTitle: 'Нууц үгээр нэвтрэх',
      adminStatusNone: 'Нууц үг тохируулаагүй.',
      adminStatusSet: 'Нууц үг тохируулсан.',
      adminStatusMustChange: 'Дараагийн нэвтрэлтэд солих шаардлагатай.',
      adminUsername: 'Нэвтрэх нэр',
      adminUsernameHint: 'Хоосон бол энд нэг удаа бөглөнө; дараа нь өөрчлөх боломжгүй.',
      adminUsernameOptional: 'Хоосон орхивол и-мэйлээрээ нэвтэрнэ.',
      adminNewPassword: 'Түр нууц үг',
      adminNewPasswordHint: 'Хүнд нь өөрөө дамжуулна уу. Анх нэвтрэхдээ солих шаардлагатай.',
      adminSet: 'Нууц үг тохируулах',
      adminReset: 'Нууц үг шинэчлэх',
      adminRemove: 'Нууц үг устгах',
      adminRemoveConfirm: 'Нууц үгийг устгах уу? Энэ хүний нээлттэй нэвтрэлтүүд дуусна.',
      adminSaved: 'Нууц үг тохируулагдлаа. Дараагийн нэвтрэлтэд солих шаардлагатай.',
      adminRemoved: 'Нууц үг устгагдлаа.',
      refusalPasswordRequired: 'Энэ хүнд и-мэйл байхгүй тул нууц үг нь нэвтрэх цорын ганц арга. Нууц үгийг устгахад нэвтрэх эрх нь хамт хасагдана.',
      refusalAccountExists: 'Энэ хүнд нэвтрэх эрх аль хэдийн байна — нууц үгийг нь тохируулах эсвэл шинэчилнэ үү.',
      refusalHasEmail: 'Энэ хүнд и-мэйл байна — эрхийг түвшний сонголтоос олгоно уу.',
      refusalNoEmailUnavailable: 'Мэдээллийн сан и-мэйлгүй эрхийг хараахан зөвшөөрөхгүй байна (шинэчлэл хийгдээгүй). Админтай холбогдоно уу.',
      grantTitle: 'Нэвтрэх нэр, нууц үгээр эрх олгох',
      grantIntro: 'Энэ хүнд и-мэйл байхгүй. Түвшин, нэвтрэх нэр, түр нууц үг өгвөл нэвтэрч чадна. Мэдэгдлийг зөвхөн апп дотор харна.',
      grantLevel: 'Хандах эрхийн түвшин',
      grantLevelPlaceholder: 'Түвшин сонгоно уу',
      grantLevelMissing: 'Түвшин сонгоно уу.',
      grantUsernameMissing: 'Нэвтрэх нэрийг оруулна уу.',
      newPasswordMissing: 'Түр нууц үгийг оруулна уу.',
      grantUsernameHint: 'Нэг удаа тохируулна; дараа нь өөрчлөх боломжгүй.',
      grantSubmit: 'Эрх олгох',
      grantSaved: 'Эрх олгогдлоо. Анх нэвтрэхдээ нууц үгээ солих шаардлагатай.',
      noEmailSwitch: 'И-мэйлгүй (хэрэглэгчийн нэр, нууц үг)',
      noEmailHint: 'Ажлын и-мэйлгүй хүнд: энэ хэрэглэгчийн нэрээр нэвтэрч, анх нэвтрэхдээ нууц үгээ солино.',
      noEmailFirstName: 'Нэр',
      noEmailLastName: 'Овог',
      noEmailFirstNameMissing: 'Нэрээ оруулна уу.',
      noEmailSubmit: 'Хэрэглэгч үүсгэх',
      adminRemoveRevokeConfirm: 'Энэ хүнд и-мэйл байхгүй тул нууц үгийг устгавал нэвтрэх эрх нь хамт хасагдана. Нээлттэй нэвтрэлтүүд дуусна. Үргэлжлүүлэх үү?',
      adminRemoveRevoke: 'Нууц үг ба эрхийг устгах',
      adminRemovedRevoked: 'Нууц үг ба нэвтрэх эрх устгагдлаа.',
      noEmailCellHint: 'И-мэйлгүй — «Нууц үг»-ээр эрх олгоно',
    },
  },
  en: {
    password: {
      handleLabel: 'Username or email',
      passwordLabel: 'Password',
      signIn: 'Sign in',
      signingIn: 'Signing in…',
      signInRefused: 'That username or password is not valid.',
      refusalCompanyDeactivated: "This company's access is turned off. Ask CenTrig to turn it back on.",
      forcedTitle: 'Choose a new password',
      forcedIntro: 'Choose your own password before you continue.',
      currentPassword: 'Current password',
      newPassword: 'New password',
      confirmPassword: 'Repeat the new password',
      change: 'Change password',
      changing: 'Saving…',
      changed: 'Password changed.',
      cardTitle: 'Change password',
      cardHint: 'Changing it signs you out on your other devices.',
      problemTooShort: 'A password must be at least 8 characters.',
      problemNeedLower: 'A password must contain a lowercase letter.',
      problemNeedUpper: 'A password must contain an uppercase letter.',
      problemNeedDigit: 'A password must contain a digit.',
      problemNeedSymbol: 'A password must contain a symbol (for example - ! @).',
      problemHasPersonal: 'A password may not contain the username, email name or person\'s name.',
      problemHasRun: 'A password may not repeat one character three times in a row.',
      problemHasSequence: 'A password may not contain a run such as 1234 or abcd.',
      refusalTooCommon: 'That password is too common. Choose another.',
      rulesTitle: 'Password rules',
      ruleMet: 'Met',
      ruleNotMet: 'Not met',
      ruleLength: 'At least 8 characters',
      ruleLower: 'A lowercase letter',
      ruleUpper: 'An uppercase letter',
      ruleDigit: 'A digit',
      ruleSymbol: 'A symbol (for example - ! @)',
      rulePersonal: 'Not the username, email name or person\'s name',
      ruleRun: 'No character three times in a row',
      ruleSequence: 'No run such as 1234 or abcd',
      ruleCommon: 'Not a common password (checked when you save)',
      showPassword: 'Show password',
      hidePassword: 'Hide password',
      problemTooLong: 'That password is too long (at most 72 bytes).',
      problemIsUsername: 'A password may not be the username.',
      problemMismatch: 'The two new passwords do not match.',
      refusalUsernameTaken: 'That username is already somebody’s username or email.',
      refusalUsernameLocked: 'This person already has a username, and it cannot be changed here.',
      refusalNotAllowed: 'This account cannot use a password: a password opens basic access only. Higher levels, Microsoft accounts and inactive accounts sign in with Microsoft.',
      refusalHolderAboveBasic: 'This person signs in with a password. A level above basic access signs in with Microsoft only, so remove their password first.',
      refusalNeedsEmail: 'Above basic access, sign-in needs a code sent by email, and this person has no email. Give them an email first.',
      refusalLevelHolders: 'Someone on this level signs in with a password, and a right you added signs in with Microsoft only. Remove their password first.',
      refusalLevelNeedsEmail: 'Someone on this level has a password but no email, and a right you added needs a code sent by email. Give them an email first.',
      basicOnlyHint: 'Only basic-access levels are listed: anything above them signs in with Microsoft.',
      refusalInvalid: 'That password does not meet the rules above.',
      refusalCurrentWrong: 'The current password is not correct.',
      refusalLocked: 'Too many wrong passwords. Try again later.',
      refusalSelf: 'You cannot set your own password here — change it from My Panel.',
      adminAction: 'Password',
      adminTitle: 'Password sign-in',
      adminStatusNone: 'No password is set.',
      adminStatusSet: 'A password is set.',
      adminStatusMustChange: 'They must change it at their next sign-in.',
      adminUsername: 'Username',
      adminUsernameHint: 'Blank today: fill it once here; it cannot be changed here afterwards.',
      adminUsernameOptional: 'Leave it blank and they sign in with their email.',
      adminNewPassword: 'Temporary password',
      adminNewPasswordHint: 'Pass it on yourself. They must change it at their first sign-in.',
      adminSet: 'Set password',
      adminReset: 'Reset password',
      adminRemove: 'Remove password',
      adminRemoveConfirm: 'Remove the password? Their open sessions end.',
      adminSaved: 'Password set. They must change it at their next sign-in.',
      adminRemoved: 'Password removed.',
      refusalPasswordRequired: 'This person has no email, so the password is their only way in. Removing it removes their access too.',
      refusalAccountExists: 'This person already has an access level — set or reset their password instead.',
      refusalHasEmail: 'This person has an email address — give them access from the level dropdown instead.',
      refusalNoEmailUnavailable: 'The database does not allow an account without an email yet (an update is still pending). Ask an administrator.',
      grantTitle: 'Give access with a username and password',
      grantIntro: 'This person has no email. Give them a level, a username and a temporary password to let them sign in. They get notifications inside the app only.',
      grantLevel: 'Access level',
      grantLevelPlaceholder: 'Choose a level',
      grantLevelMissing: 'Choose a level.',
      grantUsernameMissing: 'Enter a username.',
      newPasswordMissing: 'Enter a temporary password.',
      grantUsernameHint: 'Set once; it cannot be changed here afterwards.',
      grantSubmit: 'Give access',
      grantSaved: 'Access given. They must change the password at their first sign-in.',
      noEmailSwitch: 'No email (username and password)',
      noEmailHint: 'For someone with no work mailbox: they sign in with this username and must change the password at their first sign-in.',
      noEmailFirstName: 'First name',
      noEmailLastName: 'Last name',
      noEmailFirstNameMissing: 'Enter a first name.',
      noEmailSubmit: 'Create account',
      adminRemoveRevokeConfirm: 'This person has no email, so removing the password removes their access too. Their open sessions end. Continue?',
      adminRemoveRevoke: 'Remove password and access',
      adminRemovedRevoked: 'Password and access removed.',
      noEmailCellHint: 'No email — give access from «Password»',
    },
  },
  ru: {
    password: {
      handleLabel: 'Имя пользователя или e-mail',
      passwordLabel: 'Пароль',
      signIn: 'Войти',
      signingIn: 'Вход…',
      signInRefused: 'Неверное имя пользователя или пароль.',
      refusalCompanyDeactivated: 'Доступ этой компании отключён. Попросите CenTrig включить его снова.',
      forcedTitle: 'Задайте новый пароль',
      forcedIntro: 'Задайте собственный пароль, чтобы продолжить.',
      currentPassword: 'Текущий пароль',
      newPassword: 'Новый пароль',
      confirmPassword: 'Повторите новый пароль',
      change: 'Сменить пароль',
      changing: 'Сохранение…',
      changed: 'Пароль изменён.',
      cardTitle: 'Сменить пароль',
      cardHint: 'После смены вы выйдете на других устройствах.',
      problemTooShort: 'Пароль должен содержать не менее 8 символов.',
      problemNeedLower: 'В пароле должна быть строчная буква.',
      problemNeedUpper: 'В пароле должна быть заглавная буква.',
      problemNeedDigit: 'В пароле должна быть цифра.',
      problemNeedSymbol: 'В пароле должен быть символ (например - ! @).',
      problemHasPersonal: 'Пароль не должен содержать имя пользователя, часть email или имя человека.',
      problemHasRun: 'Нельзя повторять один символ три раза подряд.',
      problemHasSequence: 'Нельзя использовать последовательность вроде 1234 или abcd.',
      refusalTooCommon: 'Этот пароль слишком распространён. Выберите другой.',
      rulesTitle: 'Требования к паролю',
      ruleMet: 'Выполнено',
      ruleNotMet: 'Не выполнено',
      ruleLength: 'Не менее 8 символов',
      ruleLower: 'Строчная буква',
      ruleUpper: 'Заглавная буква',
      ruleDigit: 'Цифра',
      ruleSymbol: 'Символ (например - ! @)',
      rulePersonal: 'Без имени пользователя, части email и имени человека',
      ruleRun: 'Без трёх одинаковых символов подряд',
      ruleSequence: 'Без последовательностей вроде 1234 или abcd',
      ruleCommon: 'Не распространённый пароль (проверяется при сохранении)',
      showPassword: 'Показать пароль',
      hidePassword: 'Скрыть пароль',
      problemTooLong: 'Пароль слишком длинный (не более 72 байт).',
      problemIsUsername: 'Пароль не может совпадать с именем пользователя.',
      problemMismatch: 'Новые пароли не совпадают.',
      refusalUsernameTaken: 'Это имя уже используется как имя пользователя или e-mail.',
      refusalUsernameLocked: 'У этого человека уже есть имя пользователя; здесь его изменить нельзя.',
      refusalNotAllowed: 'Эта учётная запись не может использовать пароль: пароль открывает только базовый доступ. Более высокие уровни, учётные записи Microsoft и неактивные входят через Microsoft.',
      refusalHolderAboveBasic: 'Этот человек входит по паролю. Уровень выше базового входит только через Microsoft, поэтому сначала удалите его пароль.',
      refusalNeedsEmail: 'Для уровня выше базового вход требует кода по электронной почте, а у этого человека её нет. Сначала укажите почту.',
      refusalLevelHolders: 'Кто-то на этом уровне входит по паролю, а добавленное право требует входа только через Microsoft. Сначала удалите пароль.',
      refusalLevelNeedsEmail: 'У кого-то на этом уровне есть пароль, но нет почты, а добавленному праву нужен код по почте. Сначала укажите почту.',
      basicOnlyHint: 'Показаны только уровни базового доступа: всё, что выше, входит через Microsoft.',
      refusalInvalid: 'Пароль не соответствует правилам выше.',
      refusalCurrentWrong: 'Текущий пароль неверен.',
      refusalLocked: 'Слишком много неверных попыток. Повторите позже.',
      refusalSelf: 'Свой пароль здесь задать нельзя — смените его в «Моей панели».',
      adminAction: 'Пароль',
      adminTitle: 'Вход по паролю',
      adminStatusNone: 'Пароль не задан.',
      adminStatusSet: 'Пароль задан.',
      adminStatusMustChange: 'При следующем входе его нужно сменить.',
      adminUsername: 'Имя пользователя',
      adminUsernameHint: 'Сейчас пусто: заполните один раз; позже здесь его изменить нельзя.',
      adminUsernameOptional: 'Оставьте пустым — вход будет по e-mail.',
      adminNewPassword: 'Временный пароль',
      adminNewPasswordHint: 'Передайте его сами. При первом входе его нужно сменить.',
      adminSet: 'Задать пароль',
      adminReset: 'Сбросить пароль',
      adminRemove: 'Удалить пароль',
      adminRemoveConfirm: 'Удалить пароль? Открытые сеансы этого человека завершатся.',
      adminSaved: 'Пароль задан. При следующем входе его нужно сменить.',
      adminRemoved: 'Пароль удалён.',
      refusalPasswordRequired: 'У этого человека нет e-mail, поэтому пароль — единственный способ входа. Удаление пароля снимет и доступ.',
      refusalAccountExists: 'У этого человека уже есть уровень доступа — задайте или сбросьте пароль.',
      refusalHasEmail: 'У этого человека есть e-mail — выдайте доступ через выбор уровня.',
      refusalNoEmailUnavailable: 'База данных пока не допускает учётную запись без e-mail (обновление не применено). Обратитесь к администратору.',
      grantTitle: 'Выдать доступ по имени пользователя и паролю',
      grantIntro: 'У этого человека нет e-mail. Задайте уровень, имя пользователя и временный пароль, чтобы он мог войти. Уведомления он видит только в приложении.',
      grantLevel: 'Уровень доступа',
      grantLevelPlaceholder: 'Выберите уровень',
      grantLevelMissing: 'Выберите уровень.',
      grantUsernameMissing: 'Введите имя пользователя.',
      newPasswordMissing: 'Введите временный пароль.',
      grantUsernameHint: 'Задаётся один раз; позже здесь его изменить нельзя.',
      grantSubmit: 'Выдать доступ',
      grantSaved: 'Доступ выдан. При первом входе пароль нужно сменить.',
      noEmailSwitch: 'Без почты (имя пользователя и пароль)',
      noEmailHint: 'Для сотрудника без рабочей почты: он входит по этому имени пользователя и при первом входе меняет пароль.',
      noEmailFirstName: 'Имя',
      noEmailLastName: 'Фамилия',
      noEmailFirstNameMissing: 'Введите имя.',
      noEmailSubmit: 'Создать учётную запись',
      adminRemoveRevokeConfirm: 'У этого человека нет e-mail, поэтому удаление пароля снимет и доступ. Открытые сеансы завершатся. Продолжить?',
      adminRemoveRevoke: 'Удалить пароль и доступ',
      adminRemovedRevoked: 'Пароль и доступ удалены.',
      noEmailCellHint: 'Без e-mail — доступ через «Пароль»',
    },
  },
}
